import LazyDisp from "../class/lazydisp";
import GET_ARTICLES from '../class/getArticles';

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];

const domReady = TPL => {
  const recruitRequirement = new GET_ARTICLES('.recruit-requirement__list[data-plugin="getArticles"]');
  recruitRequirement.makeItem = (item,content) => `
    <div class="${content}-requirement__item${(item.is_new)? ' is-new':''}">
      <a href="${item.href}" class="${content}-requirement__item-link">
        <figure class="${content}-requirement__item-img">
          <img src="${item.thumb}" alt="${item.title}" width="100%" loading="lazy">
        </figure>
        <div class="${content}-requirement__item-body">
          <span class="is-subject">${item.title}</span>
          <p class="is-body">${item.body.replace(/(<([^>]+)>)/gi, "").str_truncate(150)}</p>
        </div>
      </a>
      <!-- /.${content}-requirement__item-link -->
    </div>
    <!-- /.${content}-requirement__item -->`;
    recruitRequirement.render()
};

const jqInit = () => {
  // LazyDisp開始
  Promise.all([w.load['loadHtml']]).then(() => new LazyDisp('[data-lazydisp]'));
};

export default function RECRUIT () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  $(() => jqInit());
}